export default __webpack_public_path__ + "static/media/flashcards2.5cfd46b9.jpg";